import clsx from 'clsx';
import { HiCheckCircle } from 'react-icons/hi';
import { Link } from 'react-router';

export interface StepListStep {
  name: string;
  href: string;
  status: 'complete' | 'current' | 'upcoming';
}

interface Props {
  steps: StepListStep[];
  className?: string;
  onClick?: () => void;
}

export default function StepsList({
  steps,
  className,
  onClick,
}: Props): JSX.Element {
  return (
    <div className={clsx('py-12', className)}>
      <nav className="flex" aria-label="Progress">
        <ol className="space-y-6">
          {steps.map((step) => (
            <li key={step.name}>
              {(() => {
                switch (step.status) {
                  case 'complete':
                    return (
                      <Link onClick={onClick} to={step.href} className="group">
                        <span className="flex items-start">
                          <span className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center">
                            <HiCheckCircle
                              className="h-full w-full text-blue-600 group-hover:text-blue-800"
                              aria-hidden="true"
                            />
                          </span>
                          <span className="ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900">
                            {step.name}
                          </span>
                        </span>
                      </Link>
                    );
                  case 'current':
                    return (
                      <Link
                        onClick={onClick}
                        to={step.href}
                        className="flex items-start"
                        aria-current="step"
                      >
                        <span
                          className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
                          aria-hidden="true"
                        >
                          <span className="absolute h-4 w-4 rounded-full bg-blue-200" />
                          <span className="relative block h-2 w-2 rounded-full bg-blue-600" />
                        </span>
                        <span className="ml-3 text-sm font-medium text-blue-600">
                          {step.name}
                        </span>
                      </Link>
                    );
                  case 'upcoming':
                    return (
                      <Link
                        onClick={onClick}
                        to={step.href}
                        className={clsx(
                          'group',
                          step.name === 'Pay' ? 'pointer-events-none' : '',
                        )}
                      >
                        <div className="flex items-start">
                          <div
                            className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
                            aria-hidden="true"
                          >
                            <div className="h-2 w-2 rounded-full bg-gray-300 group-hover:bg-gray-400" />
                          </div>
                          <p className="ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900">
                            {step.name}
                          </p>
                        </div>
                      </Link>
                    );
                  default:
                    throw new Error(
                      `Unknown step status ${step.status as string}`,
                    );
                }
              })()}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}
